// packages/web/src/services/subscription.api.ts
// ═══════════════════════════════════════════════════════════════════
// Subscription & Billing API client
// ═══════════════════════════════════════════════════════════════════

import { apiClient } from './api.client';

export interface SubscriptionPlan {
  id: string;
  name: string;
  tier: string;
  max_employees: number;
  price_monthly: number;
  price_yearly: number;
  entitlements: { modules?: Record<string, boolean>; [key: string]: any };
  is_active: boolean;
}

export interface OrgSubscription {
  id: string;
  organization_id: string;
  plan_id: string;
  status: string;
  trial_ends_at: string | null;
  current_period_end: string | null;
  subscription_plans: SubscriptionPlan;
}

export interface UsageDashboard {
  plan_name: string;
  tier: string;
  seats: { used: number; max: number; remaining: number };
  subscription_status: string;
  trial_ends_at: string | null;
  current_period_end: string | null;
  features: Record<string, boolean>;
  entitlements: Record<string, any>;
}

/** Publicly available plans */
export function listPlans() {
  return apiClient.get<SubscriptionPlan[]>('/subscriptions/plans');
}

export function getPlan(planId: string) {
  return apiClient.get<SubscriptionPlan>(`/subscriptions/plans/${planId}`);
}

/** Current org's subscription (authenticated) */
export function getMySubscription() {
  return apiClient.get<OrgSubscription>('/subscriptions/my');
}

/** Seat usage & feature dashboard (authenticated) */
export function getUsageDashboard() {
  return apiClient.get<UsageDashboard>('/subscriptions/usage');
}

/** Change subscription plan (admin) */
export function changePlan(planId: string) {
  return apiClient.put('/subscriptions/change-plan', { plan_id: planId });
}

/** Billing invoices (admin) */
export function listInvoices() {
  return apiClient.get<any[]>('/subscriptions/invoices');
}
